import { call } from "redux-saga/effects";

import API from "modules/api/api";
import { composeSaga, withErrorHandling } from "modules/root/saga-helpers";

function* getLoginImpl() {
  return yield call(API.user.tempLogin);
}

export const getLogin = getLoginImpl;

function* getUserImpl() {
  return yield call(API.user.getUser);
}

export const getUser = getUserImpl;

function* updateUserImpl(options) {
  return yield call(API.user.updateUser, options);
}

export const updateUser = composeSaga(withErrorHandling, updateUserImpl);



// WEBPACK FOOTER //
// ./src/modules/user/user-api-saga.js